<template>
    <div class="tw-flex tw-flex-col tw-items-center">
        <div class="tw-my-4 tw-w-full">
            <template>
                <span class="tw-text-black">{{ $t('configure-car.select-color') }}:&nbsp;</span>
                <span class="tw-font-black tw-text-black">{{ selectedColor.description }}</span>
            </template>
        </div>
        <loading-wrapper v-if="colorList.length" :loading="colorSelectionIsBusy">
            <color-selector :items="colorList" @item-click="onColorSelection" />
        </loading-wrapper>
    </div>
</template>

<script>
/**
 * A car configurator component
 */
export default {
    name: 'ColorSelection',
    components: {
        LoadingWrapper: () => ({
            component: import(
                /* webpackChunkName: "LoadingWrapper-vue" */ '@v4/common/components/atoms/LoadingWrapper'
            ),
        }),
        ColorSelector: () => ({
            component: import(
                /* webpackChunkName: "ColorSelector-vue" */ '@v4/common/components/molecules/ColorSelector'
            ),
        }),
    },
    props: {
        /**
         * Fallback image to use when empty colors
         */
        colorImage: {
            type: String,
            default: '',
        },
        /**
         * Color items
         */
        colors: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            colorInteracted: false,
            colorSelectionIsBusy: false,
            colorList: this.colors.map((color) => ({
                ...color,
                active: false,
            })),
        };
    },
    computed: {
        selectedColor() {
            if (this.colorList.length && !this.colorInteracted) {
                // eslint-disable-next-line no-unused-vars
                const { description, ...color } = this.colorList[0];

                return color;
            }

            return this.colorList.find((color) => color.active) || {};
        },
    },
    methods: {
        onColorSelection(index) {
            const item = this.colorList[index];

            if (item && item.active) {
                return;
            }

            this.colorSelectionIsBusy = this.colorInteracted && index > 0;
            this.colorInteracted = true;

            const color = this.setActiveByPropertyAndIndex('colorList', index);

            /**
             * Fired when a color it's selected
             *
             * @event color-select
             * @type {object}
             * @property {object} color - Color item
             */
            this.$emit('color-select', color);
        },
        onImageLoad() {
            this.colorSelectionIsBusy = false;
        },
        setActiveByPropertyAndIndex(property, index) {
            const foundItem = (this[property] && this[property][index]) || null;

            if (!foundItem) {
                return;
            }

            this[property] = this[property].map((item) => ({ ...item, active: false }));
            this.$set(this[property], index, { ...foundItem, active: true });

            return foundItem;
        },
    },
};
</script>
